module.exports = __webpack_public_path__ + "static/media/EBGaramond-Regular.4ae6bf0e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/EBGaramond-Regular.ttf
// module id = 3101
// module chunks = 71